module.exports = __webpack_public_path__ + "img/locker-front-icon.d7de1ff2.svg";